import React, { useCallback } from 'react';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button } from '@atlas/ui';

import StaticBlock from 'common/StaticBlock/StaticBlock';

const MultiPopup = ({ data: { link = '', open = '_top', staticBlock } = {}, id }) => {
  const onCloseHandler = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className="messages-popup messages-popup-multi">
      <div className="messages-popup__content messages-popup__content-multi">
        <StaticBlock
          options={{
            source: staticBlock,
          }}
        />
      </div>

      <div className="messages-popup__control">
        <Button
          className="secondary big block"
          label="multi_popup_button_name_close"
          onClick={onCloseHandler}
        />
        <Button
          className="primary big block"
          label="multi_popup_button_name"
          onClick={onCloseHandler}
        >
          {!!link && <a className="messages-popup__control-link" href={link} target={open} />}
        </Button>
      </div>
    </BasePopup>
  );
};

export default MultiPopup;
